import { InputHTMLAttributes, useState } from 'react';
import { Eye, EyeOff, Lock } from 'lucide-react';
import { Input } from '@/components/ui/Input';

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> & {
  withIcon?: boolean;
};

/** Password field with a built-in show/hide toggle and an optional lock icon. */
export function PasswordInput({ withIcon = true, ...rest }: Props) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <Input
        type={show ? 'text' : 'password'}
        leftIcon={withIcon ? <Lock size={18} /> : undefined}
        className="pr-12"
        {...rest}
      />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        tabIndex={-1}
        aria-label={show ? 'Hide password' : 'Show password'}
        className="absolute right-4 top-1/2 -translate-y-1/2 text-white/40 hover:text-white/70 transition-colors"
      >
        {show ? <EyeOff size={18} /> : <Eye size={18} />}
      </button>
    </div>
  );
}
